import { BalanceData } from "../data/balance";

/** A tower is owned when its unlock level is at most the next level to play (highest cleared + 1) (§4.5). */
export function ownedTowers(balance: BalanceData, highestLevelCleared: number): boolean[] {
  const reach = highestLevelCleared + 1;
  return balance.towers.map((t) => !t.isBase && t.unlockLevel <= reach);
}
